export default dir => {
    return obj => {
        const result = Object.assign({}, obj);

        result.img = `${process.env.VUE_APP_PIX_HOST}${dir}/${obj.img}`;

        const executor = (resolve, reject) => {
            const img = new Image();

            img.onload = () => resolve(result);
            img.src = result.img;

            setTimeout(reject, 10e3);
        };

        return new Promise(executor);
    };
};
